import { env, isDevelopment } from './env';
import { webConfig } from './webConfig';

/**
 * Return the fully qualified Hive domain with protocol.
 */
export function getHiveEndpoint(): string {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        return 'http://127.0.0.1:7001';
    }

    if (process.env.HIVE_V2) {
        if (isDevelopment || env === 'test') {
            return 'http://localhost:3100';
        }
        return `https://v2-${webConfig.services.content.host}`;
    }

    return `https://${webConfig.services.content.host}`;
}
